import React, { useEffect, useState } from "react";
import {
  abhaSuggestionsServices,
  abhaCreateServices,
  UpdateAbhaUserServices,
} from "../../services";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import abdm_config from "../../config";
import { Button } from "bootstrap";
import Modal from "react-modal";

Modal.setAppElement("#root");

const AbhaSuggestions = ({
  setAdhaaddress,
  setMobileVerificationOTPSent1,
  setCurrentStep,
}) => {
  const [abhaaddress, setAbhaaddress] = useState("");
  const [suggestionList, setsuggestionList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userInfo = useSelector((state) => state.user.patientDetails);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const patientData = JSON.parse(localStorage.getItem("selectedIndex"));
  //   try {
  //     const body = {
  //       referenceId: uuidv4(),
  //       txnId: localStorage.getItem("txnId"),
  //       abhaAddress: abhaaddress,
  //       mobile: userInfo.mobile,
  //       xToken: userInfo.xToken,
  //       patientId: patientData.pId,
  //     };
  //     const response = await abhaCreateServices({ body });
  //     console.log("ABHA Create Response:", response);

  //     if (response.status) {
  //       const patientData = JSON.parse(localStorage.getItem("selectedIndex"));
  //       console.log("patientData", patientData);
  //       console.log("userInfo id", patientData?.pId);

  //       const dob = new Date(userInfo.dob);
  //       const yyyy = dob.getFullYear();
  //       const mm = String(dob.getMonth() + 1).padStart(2, "0");
  //       const dd = String(dob.getDate()).padStart(2, "0");
  //       const formattedDob = `${yyyy}-${mm}-${dd}`;

  //       const body = {
  //         patientId: patientData?.pId,
  //         abhaAddress: userInfo.abhaAddress,
  //         healthIdnumber: userInfo.abhaNumber,
  //         abhaDOB: formattedDob,
  //         abhaGender: userInfo.gender,
  //         abhaName:
  //           userInfo.firstName +
  //           " " +
  //           userInfo.middleName +
  //           " " +
  //           userInfo.lastName,

  //         // abhaCard: response.result
  //       };
  //       console.log("Update ABHA User Body:", body);

  //       const responsed = await UpdateAbhaUserServices({ body });
  //       setCurrentStep("AbhaCard");
  //     } else {
  //       toast.error(
  //         response.result.abhaAddress || "Failed to create ABHA Address"
  //       );
  //     }
  //   } catch (error) {
  //     // toast.error(error.result.abhaAddress || "Failed to create ABHA Address");
  //     console.error("Error while getting token:", error);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const patientData = JSON.parse(localStorage.getItem("selectedIndex"));

    try {
      const body = {
        referenceId: uuidv4(),
        txnId: localStorage.getItem("txnId"),
        abhaAddress: abhaaddress,
        mobile: userInfo.mobile,
        xToken: userInfo.xToken,
      };
      if (patientData?.pId) {
        body.patientId = patientData.pId;
      }
      const response = await abhaCreateServices({ body });
      console.log("ABHA Create Response:", response);

      if (!response?.status) {
        toast.error(
          response?.result?.error?.message ||
            response?.message ||
            "Failed to create ABHA Address"
        );
        return;
      }
      localStorage.setItem("userData", JSON.stringify(response?.result));
      setCurrentStep("AbhaCard");
    } catch (error) {
      console.error("Error while creating ABHA:", error);
      toast.error(
        error?.message ||
          "Something went wrong while creating ABHA. Please try again."
      );
    }
  };

  const getsuggesion = async () => {
    try {
      const body = {
        txnId: localStorage.getItem("txnId"),
      };
      const response = await abhaSuggestionsServices({ body });
      if (response.status) {
        let suggestiondata = response.result.abhaAddressList;
        setsuggestionList(suggestiondata);
      }
    } catch (error) {
      console.error("Error while getting token:", error);
    }
  };
  useEffect(() => {
    getsuggesion();
  }, []);

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA and store all your medical records in one place.
                  Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA .
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA .</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <h3>Choose your Pathkind Profile</h3>
                <p>Choose profile to Create/link your ABHA </p>
                <form onSubmit={handleSubmit} className="pt-3">
                  <div className="col-ms-10 col-lg-10 col-xl-10 col-sm-10 col-xs-10">
                    <div className="d-flex align-items-center">
                      <input
                        type="text"
                        className="form-control suggestion-input"
                        placeholder="Enter your ABHA "
                        value={abhaaddress}
                        autoComplete="off"
                        onChange={(e) => setAbhaaddress(e.target.value)}
                      />
                      <p className="patient-name suggestion-input-placeholder">
                        {/* @sbx */}
                        {abdm_config.abdm_env}
                      </p>
                    </div>
                    {/* <p className="pt-3">
                      8-18 Characters alphabets and numbers only
                    </p> */}
                    <a
                      type="button"
                      className="view-abha mt-3"
                      onClick={openModal}
                    >
                      View the ABHA Validation Rules
                    </a>
                    <p className="pt-3 pb-1">Suggestions:</p>
                    <div className="row">
                      <div className="suggestion-profile">
                        {suggestionList?.map((suggestion, index) => (
                          <div
                            key={index}
                            className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12"
                            onClick={() => setAbhaaddress(suggestion)}
                            style={{ cursor: "pointer" }}
                          >
                            <div className="d-flex align-items-center suggestion p-2 mb-2 rounded">
                              <h5 className="mb-1 suggestion-address">
                                {suggestion}
                                {abdm_config.abdm_env}
                              </h5>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12 pt-3">
                    <div className="row">
                      <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
                        <button type="submit" className="confirm-btn">
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="ABHA Validation Rules"
        className="custom-modal"
        overlayClassName="custom-overlay"
      >
        {/* Close Button */}
        <button className="modal-close-icon" onClick={closeModal}>
          &times;
        </button>
        <h2>ABHA Address Validation Rules</h2>
        <ul>
          <li>Minimum length - 8 characters</li>
          <li>Maximum length - 18 characters</li>
          <li>Allowed special characters: 1 dot (.) and/or 1 underscore (_)</li>
          <li>
            Special characters must be in between. Not at the beginning or end.
          </li>
          <li>
            Alphanumeric: only letters, only numbers, or a combination of both.
          </li>
        </ul>
      </Modal>
    </>
  );
};

export default AbhaSuggestions;
